<template>
  <v-container id="container_completed">
    <v-card>
      <v-card-text>
        <v-row>
          <v-col>
            <h2 v-if="!club && club.length === 0">Vielen Dank für Ihre Anmeldung!</h2>
            <h2 v-else>Vielen Dank für Ihre Anmeldung bei {{ club }}!</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="status == 'Erfolg'">
            <h3 class="green--text">Die Anmeldung war erfolgreich.</h3>
            <br>
            Ihre Anmeldung ist jetzt <b>abgeschlossen</b>. Sollten Sie noch Fragen haben, können Sie uns gerne per Mail
            oder direkt telefonisch kontaktieren.
            <br>
            <br>
            <!-- App ad -->
            <v-col>
              <v-card>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-card-text class="text-center d-flex flex-column align-center pb-0">
                        <h3>Kennen Sie die VereinsZeit-App?</h3>

                        <v-img :src="require('@/assets/icon_vz.png')" alt="VereinsZeit App" width="120" height="120"
                          class="ma-2" />

                        Mit VereinsZeit haben Sie alle Ihre Mitgliedsinformationen immer dabei.<br />

                        Sie können Ihre Mitgliedsdaten verwalten, Ihre Mitgliedsbeiträge einsehen und Hallen und Kurse
                        buchen - die Sie direkt aus der App per Paypal oder Klarna bezahlen können!<br />

                        Mehr Informationen finden Sie auf unserer Webseite:<br />
                        <a href="https://vereinszeit-app.de/" target="_blank">vereinszeit-app.de</a><br /><br />


                        <h3 class="text-center">Laden Sie die App jetzt herunter!</h3>
                        <br />
                        <v-row>
                          <!-- Google Play Badge + QR -->
                          <v-col>
                            <div class="d-flex flex-column flex-no-wrap align-center">
                              <v-btn href="https://play.google.com/store/apps/details?id=com.vereinszeit"
                                target="_blank" class="pa-0"
                                style="min-width: 0; min-height: max-content; background: transparent; box-shadow: none;"
                                elevation="0">
                                <v-img :src="require('@/assets/google-play-black.png')" alt="Google Play" width="175"
                                  height="55" contain />
                              </v-btn>
                              <!-- QR Code- only displayed on desktop -->
                              <v-img v-if="!isMobile()"  :src="require('@/assets/qrcode_playstore.png')" alt="QR Code Google Play"
                                width="175" height="175" />
                            </div>
                          </v-col>
                          <!-- App Store Badge + QR -->
                          <v-col>
                            <div class="d-flex flex-column flex-no-wrap align-center">
                              <v-btn href="https://apps.apple.com/de/app/vereinszeit/id1593616309" target="_blank"
                                class="pa-0"
                                style="min-width: 0; min-height: max-content; background: transparent; box-shadow: none;"
                                elevation="0">
                                <v-img :src="require('@/assets/app-store-black.png')" alt="App Store" width="175"
                                  height="55" contain />
                              </v-btn>
                              <!-- QR Code- only displayed on desktop -->
                              <v-img v-if="!isMobile()" :src="require('@/assets/qrcode_appstore.png')" alt="QR Code App Store" width="175"
                                height="175" />
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-col>
          <v-col v-if="status == 'Fehler'">
            <h3 class="red--text">Bei der Anmeldung ist ein Fehler aufgetreten.</h3>
            <br>
            Bei Ihrer Anmeldung ist leider etwas <b>schiefgelaufen</b>.<br>
            Bitte kontaktieren Sie unseren Verein direkt, mit angabe des untenstehenden Fehlers.<br>
            Entschuldigen Sie die Unannehmlichkeiten.<br>
            <br>
            <v-card v-if="$te('confirmStatusCodes.code_' + statusCode)">
              <v-card-text>
                <v-col>
                  <b>Meldung:</b> {{ $t('confirmStatusCodes.code_' + statusCode) }}
                </v-col>
                <v-col>
                  <b>Statuscode:</b> {{ statusCode }}
                </v-col>
              </v-card-text>
            </v-card>
            <v-card v-else>
              <v-card-text>
                <v-col>
                  <b class="red--text">Ein unbekannter Fehler ist aufgetreten.</b>
                </v-col>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      club: this.$route.query?.club,
      statusCode: this.$route.query?.statusCode
    }
  },

  props: {
    status: { type: String, default: '' },
  },

  methods: {
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
        return true;
      return false;
    },
  }
}
</script>

<style lang="scss">
#container_completed {
  min-width: 350;
  margin-top: 5%
}
</style>